import Header from 'components/headers/funds'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import useGetRequestMessage from './hooks/useGetRequestMessage'
import useGetCashboxMessages from './hooks/useGetCashboxMessages'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'

export default function MessagesPage() {
    const navigate = useNavigate()
    const { requestMessage, isLoading, fetchNextPage } = useGetRequestMessage()
    const { cashboxData } = useGetCashboxMessages()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])

    const messages = requestMessage
        ? requestMessage.pages.flatMap((x) => x.result)
        : []

    // fragment_message.xml request_container: count from invited-and-request
    // list (MessageFragment.updateInviteTextView). Band hidden when count == 0.
    const inviteCount =
        (cashboxData as { results?: unknown[] } | undefined)?.results?.length ??
        0

    return (
        <>
            <Header title="پیام ها" />
            <SideBar>
                <SideBarItems />
            </SideBar>

            <div className="min-h-screen bg-[#f9f9f9]">
                {/* request_container: 63dp band, #616161, bottom hairline #EFEFEF */}
                {inviteCount > 0 && (
                    <button
                        type="button"
                        onClick={() => navigate('/cashbox/invitations')}
                        className="relative flex h-[63px] w-full items-center justify-between border-b border-[#EFEFEF] bg-[#616161] active:opacity-90"
                    >
                        {/* request_text_view (far right, marginRight 16dp) with the
                            count badge to its left (invite_count_bg #E84524, 5dp
                            radius, 27x20dp, marginRight 9dp) */}
                        <div className="flex items-center">
                            <span className="mr-4 text-sm font-normal text-white">
                                درخواست عضویت
                            </span>
                            <div className="mr-[9px] flex h-5 w-[27px] items-center justify-center rounded-[5px] bg-[#E84524]">
                                <span className="text-xs font-normal text-white">
                                    {inviteCount}
                                </span>
                            </div>
                        </div>

                        {/* ic_more_small_white: 11x11dp, far left, marginLeft 19dp */}
                        <svg
                            className="ml-[19px] h-[11px] w-[11px]"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.5 1.5L3 5.5L7.5 9.5"
                                stroke="#FFFFFF"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                )}

                {/* message_rv: clipToPadding=false, paddingTop/Bottom 4dp */}
                <div className="py-1">
                    <InfiniteScroll
                        hasMore={
                            requestMessage
                                ? requestMessage.pages[
                                      requestMessage?.pages.length - 1
                                  ].last_date
                                    ? true
                                    : false
                                : false
                        }
                        next={onWatchEnd}
                        dataLength={messages.length}
                        loader={<DotsLoading />}
                    >
                        {requestMessage ? (
                            messages.length > 0 ? (
                                messages.map((item, index) => (
                                    <Item item={item} key={index} />
                                ))
                            ) : (
                                <p className="mt-16 text-center text-sm font-normal text-text-secondary">
                                    پیامی وجود ندارد
                                </p>
                            )
                        ) : (
                            <DotsLoading />
                        )}
                    </InfiniteScroll>
                </div>
            </div>
        </>
    )
}
